import React from 'react'
import PropTypes from 'prop-types'

// Utils
import AuthError from 'src/features/auth/AuthError'

// Components
import { If } from 'src/deprecated/Conditionals'
import Loading from 'src/Components/shared/Loading/LoadingApp'
import OverlayMask from 'src/Components/shared/Routing/OverlayMask'
import AppHeader from './AppHeader'

const AppLayout = ({
  children,
  enableAgentDropdown,
  error,
  loading,
  match,
  ...restProps
}) => {
  const appHeaderProps = {
    enableAgentDropdown,
    ...restProps,
  }

  return (
    <>
      <If condition={loading}>
        <Loading />
      </If>
      <OverlayMask loading={loading} isExact={match.isExact}>
        <AppHeader {...appHeaderProps} />
        <If condition={!error}>{children}</If>
      </OverlayMask>
      <AuthError />
    </>
  )
}

AppLayout.propTypes = {
  children: PropTypes.any,

  enableAgentDropdown: PropTypes.bool,
  error: PropTypes.bool,

  loading: PropTypes.bool,
  match: PropTypes.shape({
    isExact: PropTypes.bool,
  }),
}

export default AppLayout
